'use client';

import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon, MinusIcon } from 'lucide-react';
import * as React from 'react';

import { cn } from '@/lib/utils';

function Checkbox({
  className,
  indeterminate,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root> & {
  indeterminate?: boolean;
}) {
  const ref = React.useRef<HTMLButtonElement>(null);

  React.useEffect(() => {
    if (ref.current) {
      (ref.current as HTMLInputElement).indeterminate = indeterminate ?? false;
    }
  }, [indeterminate]);

  return (
    <CheckboxPrimitive.Root
      ref={ref}
      data-slot="checkbox"
      className={cn(
        'peer border-ihs-blue dark:bg-ihs-blue/30 data-[state=checked]:bg-ihs-blue data-[state=checked]:text-primary-foreground dark:data-[state=checked]:bg-ihs-blue/70 data-[state=checked]:border-ihs-blue focus-visible:border-ihs-blue focus-visible:ring-ihs-blue/20 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        indeterminate && 'border-ihs-blue text-ihs-blue',
        className
      )}
      {...props}
    >
      {indeterminate ? (
        <MinusIcon className="size-3.5 " />
      ) : (
        <CheckboxPrimitive.Indicator
          data-slot="checkbox-indicator"
          className={cn(
            'flex items-center justify-center text-white transition-none'
          )}
        >
          <CheckIcon className="size-3.5" />
        </CheckboxPrimitive.Indicator>
      )}
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
